import { Container, FlexBox } from "@components/wrapper"
import React from "react"
import { BootcampComponentProps } from "."
import { BootcampHeading } from "../general/ProgramHeading"
import { IoMdCheckmark } from "react-icons/io"
import clsx from "clsx"
import Image from "next/image"
import { chunk } from "@lib/functions/array"
import { useScreenSize } from "@lib/hooks/useScreenSize"

export const BootcampOverview = ({ schoolDetail }: BootcampComponentProps) => {
  const {screenWidth} = useScreenSize()
  const toolsChunk = chunk(schoolDetail.school_tools, screenWidth > 576 ? 4 : 3)

  return (
    <Container className="sm:py-[80px] py-10">
      <div className="sm:flex grid sm-only:gap-6">
        <div className="sm:flex-1 flex flex-col relative sm:gap-9 gap-6">
          <div>
            <BootcampHeading
              id="overview"
              title="Overview & Benefit"
              // subTitle={`Jadi ${schoolDetail.product_name} Dalam Hitungan Minggu`}
              subTitle="Raih Karir Impian Dalam Hitungan Minggu"
            />
          </div>

          <div className="grid gap-4">
            {schoolDetail.school_overview_benefits.map((ben) => (
              <FlexBox key={ben.id} className="gap-2">
                <IoMdCheckmark className="text-new-blue mt-1" />
                <div className="text-primary-black font-medium w-[90%]">{ben.description}</div>
              </FlexBox>
            ))}
          </div>
        </div>

        <div className="w-[10%]" />

        <div className="sm:w-[42%] w-full">
          <div className={clsx("bg-white rounded-lg card-box grid", "sm:p-9 sm:gap-9 p-5 gap-6")}>
            <div className="font-urbanist sm:text-xl text-sm font-bold flex gap-2">
              <span className="">💻</span> Tools Yang Akan Kamu Pelajari
            </div>
            <div className="grid sm:gap-6 gap-3">
              {toolsChunk.map((tools, idx) => (
                <div
                  className={clsx("sm:flex grid sm:gap-6 gap-3", "sm:grid-cols-4 grid-cols-3")}
                  key={idx}
                >
                  {" "}
                  {tools.map((value: any, index) => (
                    <div key={index} className="">
                      <Image
                        className="object-contain w-auto sm:h-9"
                        src={value.tool_path}
                        alt={value.tool_title}
                        width={100}
                        height={100}
                        title={value.tool_title}
                      />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}
